import type { CSSProperties, ReactNode } from "react";

export interface WidgetStateProps {
  title: ReactNode;
  description?: ReactNode;
  tone?: "neutral" | "error";
  /** A single follow-up control under the text (the shared issue state's Retry). */
  action?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function WidgetState({
  title,
  description,
  tone = "neutral",
  action,
  className,
  style,
}: WidgetStateProps) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      style={style}
      className={[
        "density-widget-body flex h-full min-h-(--widget-state-min-height) min-w-0 flex-col items-center justify-center gap-1.5 text-center",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <p
        className={
          tone === "error"
            ? "text-sm font-medium text-status-error-text"
            : "text-sm font-medium text-secondary"
        }
      >
        {title}
      </p>
      {description ? <p className="max-w-prose text-xs text-muted">{description}</p> : null}
      {action ? <div className="mt-1.5">{action}</div> : null}
    </div>
  );
}
